import { z } from 'zod';
import { CursorSchema, EmailSchema, PaginationLimitSchema, TenantRoleSchema, UserStatusSchema, paginatedSchema, } from '../common.js';
import { InviteSummarySchema } from '../entities/invite.js';
import { TenantUserPublicSchema } from '../entities/tenantUser.js';
// =========================================================
// /v1/tenant/users — see docs/api.md §3.4
// =========================================================
// GET /v1/tenant/users
export const TenantUsersListQuerySchema = z.object({
    status: UserStatusSchema.optional(),
    limit: PaginationLimitSchema.optional(),
    cursor: CursorSchema.optional(),
});
export const TenantUsersListResponseSchema = paginatedSchema(TenantUserPublicSchema);
// POST /v1/tenant/users/invite
export const TenantUsersInviteRequestSchema = z.object({
    email: EmailSchema,
    firstName: z.string().min(1).max(60),
    lastName: z.string().min(1).max(60),
    role: TenantRoleSchema,
});
export const TenantUsersInviteResponseSchema = z.object({
    invite: InviteSummarySchema,
});
// GET /v1/tenant/users/invites
export const TenantUsersInvitesListQuerySchema = z.object({
    limit: PaginationLimitSchema.optional(),
    cursor: CursorSchema.optional(),
});
export const TenantUsersInvitesListResponseSchema = paginatedSchema(InviteSummarySchema);
// DELETE /v1/tenant/users/invites/{inviteId} — 204 no body
// POST /v1/tenant/users/invites/{inviteId}/resend — 204 no body
// PATCH /v1/tenant/users/{userId}
export const TenantUsersPatchRequestSchema = z
    .object({
    role: TenantRoleSchema.optional(),
    status: z.enum(['active', 'disabled']).optional(),
})
    .refine((v) => Object.keys(v).length > 0, { message: 'At least one field required.' });
export const TenantUsersPatchResponseSchema = TenantUserPublicSchema;
// DELETE /v1/tenant/users/{userId} — 204 no body
//# sourceMappingURL=users.js.map